import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch
} from "react-router-dom";
import { useUserId } from "../../../../query/hooks/helpers";
import { useMemberProfile } from "../../../../query/users/queries";
import { FormTaxProfile } from "../../../Taxes/components/FormTaxProfile";
import { FormTaxRate } from "../../../Taxes/components/FormTaxRate";
import { useOnboardingContext } from "../../Context";
import { OnboardingStep } from "../../types";
import { TaxWithholdingsContext } from "./types";

export const CalculateTaxRate: React.FC<OnboardingStep> = props => {
  const history = useHistory();
  const match = useRouteMatch();
  const basePath = match.path;

  const userId = useUserId();
  const queryMember = useMemberProfile(userId);
  const hasTaxProfileData =
    !!queryMember.data?.profile.taxInfo?.incomeEstimateForYear;

  const [_, setContext] = useOnboardingContext<TaxWithholdingsContext>();

  if (!queryMember.data) {
    return null;
  }

  return (
    <Switch>
      <Route path={basePath + "/estimate-tax-rate"}>
        <FormTaxProfile
          onBack={props.onBack}
          onNext={() => {
            history.push(basePath + "/tax-rate");
          }}
        />
      </Route>

      <Route path={basePath + "/tax-rate"}>
        <FormTaxRate
          onEditTaxProfile={() => {
            history.push(basePath + "/estimate-tax-rate");
          }}
          onBack={() => {
            history.push(basePath + "/estimate-tax-rate");
          }}
          onNext={props.onNext}
          onSkip={() => {
            setContext(prev => ({
              ...prev,
              taxWithholdingsSkipped: true
            }));
            props.onSkip?.();
          }}
        />
      </Route>

      <Redirect
        from={basePath}
        to={basePath + (hasTaxProfileData ? "/tax-rate" : "/estimate-tax-rate")}
      />
    </Switch>
  );
};
